import React from 'react'

const Header = () => {
  return (
    <div className='fixed inset-x-0 top-0 w-full py-4 text-center bg-white border-b-2 border-gray-300 shadow-md'>
      <header className=''>
        <h1 className='text-3xl font-bold text-center uppercase'>Blogs</h1>
      </header>
    </div>
  )
}

export default Header